import { render, staticRenderFns } from "./IpRangesTabGuest.vue?vue&type=template&id=4160f31a&scoped=true&"
import script from "./IpRangesTabGuest.vue?vue&type=script&lang=js&"
export * from "./IpRangesTabGuest.vue?vue&type=script&lang=js&"
import style0 from "./IpRangesTabGuest.vue?vue&type=style&index=0&id=4160f31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160f31a",
  null
  
)

export default component.exports